import { PurchaseRequisitionLineItem } from '~/common/types';

export enum PurchaseRequisitionDetailsDataGridField {
  ID = 'id',
  POSITION = 'position',
  TITLE = 'title',
  SUPPLIER = 'supplier',
  DESCRIPTION = 'description',
  UNIT = 'unit',
  PRICE_PER_UNIT = 'pricePerUnit',
  QUANTITY = 'quantity',
  CURRENCY = 'currency',
}

export type PurchaseRequisitionDetailsDataGridRow = PurchaseRequisitionLineItem;
